export default __webpack_public_path__ + "static/media/silubi-symbol.50236ef0.svg";